function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissingFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3624 3150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3588.5,-6186.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6023.62,7086.61L6023.62,6968.5L4606.3,6968.5C4401.4,7003.57 4265.65,7136.16 4251.97,7440.94L4251.97,9212.6L6023.62,9212.6L6023.62,8976.38",
    style: {
      fill: "none",
      stroke: "rgb(111,111,111)",
      strokeWidth: 175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6614.17,8503.94L7086.61,8858.27",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 250,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,118.11,-9.09495e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4251.97,6614.17L4251.97,6259.84",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "145.83px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,177.165,-59.0551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,6732.28L3661.42,6496.06",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "145.83px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,118.11,-118.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7086.61",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "145.83px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.95652,0,0,1,-2326.26,1003.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7086.61",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 118,
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1,-118.11,590.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7086.61",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "155.56px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1,1062.99,708.661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7559.06",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "155.56px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1,1062.99,708.661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7559.06",
    style: {
      fill: "none",
      stroke: "rgb(186,0,0)",
      strokeWidth: "155.56px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1,1062.99,708.661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3543.31,7086.61L3897.64,7559.06",
    style: {
      fill: "none",
      stroke: "rgb(183,0,0)",
      strokeWidth: "155.56px",
      strokeLinecap: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.66667,0,0,1,-4842.52,1417.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3897.64,7086.61L3543.31,7086.61",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "91.04px",
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.927536,0,0,1,874.701,3720.47)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5551.18,
    cy: 4311.02,
    rx: 708.661,
    ry: 649.606,
    style: {
      fill: "none",
      stroke: "rgb(0,128,98)",
      strokeWidth: "216.01px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingFile);
export default __webpack_public_path__ + "static/media/missing_file.876bdc29486b601af667ffa219c7527d.svg";
export { ForwardRef as ReactComponent };